// Celebration utilities - Confetti, streak flames, micro-goals
import confetti from 'canvas-confetti';

// Confetti celebration for achievements
export const celebrateAchievement = (type = 'default') => {
  const configs = {
    default: {
      particleCount: 100,
      spread: 70,
      origin: { y: 0.6 }
    },
    badge: {
      particleCount: 150,
      spread: 100,
      colors: ['#FFD700', '#FFA500', '#FF6B6B'],
      origin: { y: 0.5 }
    },
    streak: {
      particleCount: 80,
      spread: 60,
      colors: ['#FF6B6B', '#FF8C00', '#FFD700'],
      origin: { y: 0.7 },
      shapes: ['circle']
    },
    weight: {
      particleCount: 120,
      spread: 90,
      colors: ['#10B981', '#34D399', '#6EE7B7'],
      origin: { y: 0.6 }
    },
    workout: {
      particleCount: 100,
      spread: 80,
      colors: ['#8B5CF6', '#A78BFA', '#C4B5FD'],
      origin: { y: 0.6 }
    }
  };
  
  const config = configs[type] || configs.default;
  confetti(config);
};

// Double burst for big achievements
export const celebrateBig = () => {
  const duration = 3000;
  const end = Date.now() + duration;

  const frame = () => {
    confetti({
      particleCount: 3,
      angle: 60,
      spread: 55,
      origin: { x: 0 },
      colors: ['#FFD700', '#FF6B6B', '#10B981']
    });
    confetti({
      particleCount: 3,
      angle: 120,
      spread: 55,
      origin: { x: 1 },
      colors: ['#FFD700', '#FF6B6B', '#10B981']
    });

    if (Date.now() < end) {
      requestAnimationFrame(frame);
    }
  };
  frame();
};

// Fire emoji rain for streaks
export const fireRain = () => {
  const duration = 2000;
  const end = Date.now() + duration;
  
  const frame = () => {
    confetti({
      particleCount: 2,
      angle: 90,
      spread: 45,
      origin: { x: Math.random(), y: 0 },
      colors: ['#FF6B6B', '#FF8C00', '#FFD700'],
      shapes: ['circle'],
      gravity: 1.5,
      scalar: 1.2
    });
    
    if (Date.now() < end) {
      requestAnimationFrame(frame);
    }
  };
  frame();
};
